import { type ReactNode, useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { Spinner } from '@/components/Spinner';
import { useTranslation } from 'react-i18next';
import { ConsentGate } from '@/features/consent/ConsentGate';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const status = useAuthStore((s) => s.status);
  const login = useAuthStore((s) => s.loginWithTelegram);
  const { t } = useTranslation();

  useEffect(() => {
    if (status === 'idle') void login();
  }, [status, login]);

  if (status === 'authenticated') return <ConsentGate>{children}</ConsentGate>;

  if (status === 'unauthenticated' || status === 'error') {
    // Soft fallback: render children anyway so dev browser can preview UI.
    return (
      <>
        <div className="bg-yellow-500/20 text-yellow-200 text-xs rounded-xl px-3 py-2 mb-3">
          Dev mode: not authenticated with Telegram. Set VITE_DEV_INIT_DATA to test auth.
        </div>
        {children}
      </>
    );
  }

  return (
    <div className="flex items-center justify-center py-16 text-hint">
      <Spinner />
      <span className="sr-only">{t('common.loading')}</span>
    </div>
  );
}
